module.exports = __webpack_public_path__ + "assets/img/openingOperation.bc032c36.png";